module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/whatsapp-873311d8f7e8a70f1191bbba56b2cf48.svg";